<template>
  <a-modal
    title="添加计划需求源"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="添加"
    @cancel="close"
    @ok="confirmBtn"
    :confirmLoading="confirmLoading"
  >
    <a-table
      :columns="columns"
      :loading="pageParams.tableLoading"
      :data-source="tableList"
      :row-selection="rowSelection"
      :pagination="false"
      row-key="id"
      :scroll="{ y: 230 }"
    >
      <!-- 筛选 -->
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        class="p8"
      >
        <div v-if="column.dataIndex === 'scheduleType'" class="pb8">
          <global-select
            :value.sync="selectedKeys[0]"
            :selectData="scheduleTypeList"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :placeholder="`选择 ${column.title}`"
          />
        </div>
        <a-input
          v-else
          :placeholder="`搜索 ${column.title}`"
          :value="selectedKeys[0]"
          class="search-tb1"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'page', 'queryParams')"
        />
        <a-button
          type="primary"
          icon="search"
          size="small"
          class="search-tb2"
          @click="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'page', 'queryParams')"
        >搜索</a-button>
        <a-button size="small" class="w90" @click="() => handleReset(column.dataIndex, clearFilters, 'page', 'queryParams')">重置</a-button>
      </div>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'tag'" class="table-line">
            <span>{{ text }}</span>
            <a-tag v-if="record.message" color="red" class="tag">{{ record.message }}</a-tag>
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <!-- 底部分页按钮 -->
    <Page ref="page" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
import { apiScpPlanMrpSchedulesAdd } from '@/api/scp/planSetting/mrpPlanName'

export default {
  props: {
    planTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpScheduleNames/list',
        tableLoading: false
      },
      queryParams: {
        organizationName: undefined,
        scheduleType: undefined,
        scheduleName: undefined,
        description: undefined
      },
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown', customRender: 'organizationName' },
          type: 'tag'
        },
        {
          title: '类型',
          dataIndex: 'scheduleType',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '计划名称',
          dataIndex: 'scheduleName',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        },
        {
          title: '说明',
          dataIndex: 'description',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        }
      ],
      tableList: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      // 类型
      scheduleTypeList: [
        { realValue: "MPS", label: "MPS" },
        { realValue: "MDS", label: "MDS" }
      ]
    }
  },
  created () {},
  methods: {
    show (val) {
      this.queryParams.planName = val.planName
      this.visible = true
      this.$nextTick(() => {
        this.$refs.page.getFirstPage(this.queryParams)
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data
    },
    // 保存
    confirmBtn () {
      this.confirmLoading = true
      this.selectedRows.forEach(element => {
        element.planName = this.queryParams.planName
      });
      apiScpPlanMrpSchedulesAdd(this.selectedRows).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.length > 0) {
            const arr = JSON.parse(JSON.stringify(this.tableList))
            arr.forEach(element => {
              element.message = ""
            });
            response.data.forEach(element => {
              arr[Number(element.lineNum) - 1].message = element.message
            });
            this.tableList = arr
            this.$message.error(response.data[0].message)
            this.confirmLoading = false
            return
          }
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.queryParams = {
        organizationName: undefined,
        scheduleType: undefined,
        scheduleName: undefined,
        description: undefined
      }
      this.tableList = []
    },
    // table 头筛选-搜索
    handleSearch (selectedKeys, dataIndex, confirm, refName, queryParamsName) {
      confirm();
      this[queryParamsName][dataIndex] = selectedKeys[0]
      this.$refs[refName].getFirstPage(this[queryParamsName])
    },
    // table 头筛选-重置
    handleReset (dataIndex, clearFilters, refName, queryParamsName) {
      clearFilters();
      this[queryParamsName][dataIndex] = ""
      this.$refs[refName].getFirstPage(this[queryParamsName])
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px;
}
input{
  width: 170px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-line{
  position: relative;
  .tag{
    position: absolute;
    left: 120px;
    bottom: -30px;
    z-index: 10000000;
  }
}
.p8 {
  padding: 8px;
}
.pb8 {
  padding-bottom: 8px;
}
.search-tb1 {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-tb2 {
  width: 90px;
  margin-right: 8px
}
</style>
